// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalNext_modal__1U5Yz","modalLayout":"ModalNext_modalLayout__3ZaSF","overlay":"ModalNext_overlay__ZZpDE"};